import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import HitchRequestsList from './HitchRequestsList';

export default {
    icon: LiveHelpIcon,
    list: HitchRequestsList,
};
